let Sw = {

    conf: {
        debug: true
    },

    init: function () {

        let self = this;

        Sw.logData('Sw.init called');

        self.modals.init();

        self.validation.init();

        if ($('body').hasClass('template--customers--account') || $('body').hasClass('template--page--my-designs')) {
            self.account.init();
        }

        self.account.initDeleteDesignModal();

        if ($('body').hasClass('template--product')) {
            self.pdp.init();
        }

        if ($('body').hasClass('template--collection')) {
            self.plp.init();
        }

        if ($('body').hasClass('transparent--header')) {

            $(window).on('scroll', function () {

                let window_scrolltop = $(window).scrollTop();

                if (window_scrolltop > 0) {
                    $('body').removeClass('transparent--header');
                } else {
                    $('body').addClass('transparent--header');
                }
            })
        }

        if (typeof sw_artist != 'undefined') {
            self.artist.init();
        }

    },

    modals: {

        default_tab: 'register',

        init: function () {

            let self = this;

            Sw.logData('Sw.modals.init called');

            let sidebar_modal = $('.off-canvas--right-sidebar');
            let newsletter_modal = $('#sw_newsletter_modal');
            let size_chart_modal = $('#sw_size_chart_modal');
            let how_it_works_modal = $('#sw_how_it_works');
            let video_fs_modal = $('#sw_video_fullscreen_modal');
            let customise_shoe_modal = $('#sw_product_config_modal_customise_shoe');
            let laces_modal = $('#sw_product_config_modal_laces');

            // Prevent overflow unset when Configurator is opened
            $('.modal').on('hidden.bs.modal', function() {
                if ($('html').hasClass('configurator-opened')) {
                    $('body').css('overflow', '');
                }
            });

            if (sidebar_modal.length) {
                $('.navigation--mobile-button, .navigation--button').on('click', function () {
                    sidebar_modal.attr('data-filter_opened', $(this).data('toggle-menu'));
                });
            }

            if (newsletter_modal.length) {

                // Show newsletter modal
                if (window.location.href.indexOf(newsletter_modal.attr('id')) > -1) {
                    newsletter_modal.modal('show');
                }

                // Validate newsletter input
                let newsletter_email_input = $('#footer-email');

                if (newsletter_email_input.val().length === 0) {
                    newsletter_email_input.closest('div').find('button').attr('disabled', true);
                }
            }

            if (size_chart_modal.length) {

                size_chart_modal.on('shown.bs.modal', function () {

                    let sizes_table_slider = new Swiper('.js-sw-sizes-table-slider', {
                        slidesPerView: 1.1,
                        freeMode: true,
                        spaceBetween: 0,
                        breakpoints: {
                            768: {
                                slidesPerView: 2.1,
                                grabCursor: true
                            }
                        }
                    });
                });

                $(document).on('click', '.js-sw-modal-scroll-to-section', function () {

                    let target_container = $('#' + $(this).data('container')).get(0);

                    target_container.scrollIntoView({
                        behavior: "smooth"
                    });
                });
            }

            if (how_it_works_modal.length) {
                how_it_works_modal.on('shown.bs.modal', function (event) {
                    let button = $(event.relatedTarget);
                    let video_url = 'https://www.youtube.com/embed/' + button.data('video_id') + '?rel=0';
                    $('.js-sw-how-it-works-video').attr('src', video_url);
                });
            }

            if (video_fs_modal.length) {

                let video_id = $('.sw--video').data('video-id');
                let video_url = 'https://www.youtube.com/embed/' + video_id + '?rel=0';
                $('.js-video-inside-modal').attr('src', video_url);
            }

            if (customise_shoe_modal.length) {

                $(document).on('click', '.js-customise-shoe-back', function () {
                    $(this).closest('.modal-content-wrapper').addClass('is-hidden').prev().removeClass('is-hidden');
                });

                $(document).on('click', '.js-customise-shoe-next', function () {
                    $(this).closest('.modal-content-wrapper').addClass('is-hidden').next().removeClass('is-hidden');
                });

                customise_shoe_modal.on('hidePrevented.bs.modal', function () {

                    // Only if we are not on the first tab - close modal
                    // customise_shoe_modal.find('.modal-content-wrapper:first-child').hasClass('is-hidden')
                    // && customise_shoe_modal.modal('hide');

                    customise_shoe_modal.modal('hide')
                });

                customise_shoe_modal.on('hidden.bs.modal', function () {

                    if (customise_shoe_modal.find('#customise_shoe_modal_hide').prop('checked')) {
                        sessionStorage.setItem('customise_shoe_modal_shown', 'true');
                    }

                    customise_shoe_modal.find('.modal-content-wrapper:first-child').removeClass('is-hidden');
                    customise_shoe_modal.find('.modal-content-wrapper:last-child').addClass('is-hidden');
                });
            }

            if (laces_modal.length) {
                // Add some logic when needed
            }
        },
    },

    validation: {

        init: function () {

            let self = this;

            Sw.logData('Sw.validation.init called');

            let sw_form = $('.sw-form');

            if (sw_form.length) {

                $(document).on('click', '.sw-form button[type="submit"]', function (event) {
                    event.preventDefault();

                    let form = $(this).closest('form');
                    let form_fields = form.find('.form-field');
                    let has_errors = false;
                    let spinner = $(this).find('.js-sw-btn-spinner');

                    $.each(form_fields, function () {
                        if ($(this).hasClass('has-error')) {
                            has_errors = true;
                        }

                        if ($(this).find('input').val() === '') {
                            $(this).addClass('has-error');
                            has_errors = true;
                        }
                    });

                    if (!has_errors) {

                        // Add spinner if any
                        if (spinner.length) {
                            spinner.attr('data-spinner_hidden', false);
                        }

                        // And submit form
                        form.submit();
                    }
                });

                $(document).on('keyup', '.sw-form input[type="email"]', function () {
                    let input_value = $(this).val();
                    let regex = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;

                    if(!regex.test(input_value)) {
                        $(this).closest('.form-field').addClass('has-error');
                    } else {
                        $(this).closest('.form-field').removeClass('has-error');
                    }
                });

                $(document).on('keyup', '.sw-form input[name="customer[first_name]"], .sw-form input[name="customer[last_name]"]', function () {
                    let input_value = $(this).val();
                    let regex = new RegExp("^[a-zA-Z0-9]+$");

                    if(!regex.test(input_value)) {
                        $(this).closest('.form-field').addClass('has-error');
                    } else {
                        $(this).closest('.form-field').removeClass('has-error');
                    }
                });

                $(document).on('keyup', '.sw-form input[type="password"]', function () {
                    if ($(this).val() !== '') {
                        $(this).closest('.form-field').removeClass('has-error');
                    } else {
                        $(this).closest('.form-field').addClass('has-error');
                    }
                });
            }
        }
    },

    account: {

        init: function () {

            let self = this;

            console.log('Sw.account.init called');

            let customer_id = $('body').data('customer_id') || null;

            if (customer_id) {

                if ($('body').hasClass('page--my-designs')) {
                    Sw.getAccountCustomerDesigns(customer_id);
                }
            }
        },

        initDeleteDesignModal: function () {

            let self = this;

            let design_delete_modal = $('#sw_my_designs_delete_modal');

            if (!design_delete_modal.length) {
                return;
            }

            console.log('Sw.account.initDeleteDesignModal called');

            let ajax_url = '';

            design_delete_modal.on('shown.bs.modal', function (event) {

                let button = $(event.relatedTarget);
                ajax_url = button.data('href') || '';
            });

            $(document).on('click', '.js-sw-account-delete-design', function () {

                if (ajax_url && ajax_url !== '') {

                    // Delete design
                    self.deleteDesign(ajax_url);
                }
            });
        },



        deleteDesign: function(ajax_url) {

            console.log('Sw.account.deleteDesign called');

            $.ajax({
                url: ajax_url,
                method: "DELETE",
                "timeout": 0,
                headers: { "Accept": "application/json" },
            }).done(function (response) {

                let designs_container = $('.js-my-designs-list');

                designs_container.find('li[data-design_id="' + response.design.uuid + '"]').remove();

                if (response.count_designs === 0) {
                    designs_container.closest('.account--designs-grid').find('.js-my-designs-empty').removeClass('d-none');
                }

                // PDP designs list - a slot is freed up, so re-enable the "new design" tile
                designs_container.find('.js-new-design').closest('li').removeClass('disabled');

                $('#sw_my_designs_delete_modal').modal('hide');
            });
        }
    },

    plp: {

        init: function() {

            let price_slider = $('.js-sw-product-price-slider');

            if (price_slider.length) {

                let input_min = $(".filter--price-fields #filter--price--min");
                let input_max = $(".filter--price-fields #filter--price-max");

                price_slider.slider({
                    range: true,
                    animate: false,
                    min: price_slider.data('min-price'),
                    max: price_slider.data('max-price'),
                    values: [ input_min.val() , input_max.val() ],
                    classes: {
                        "ui-slider": "filter--price-range",
                        "ui-slider-handle": "filter--price-range--button",
                        "ui-slider-range": "filter--price-range--line",
                    },
                    stop: function (event, ui) {
                        input_min.val(ui.values[0]);
                        input_max.val(ui.values[1]);
                    }
                });
            }

        }
    },

    pdp: {

        init: function() {

            let self = this;

            console.log('Sw.pdp.init called');

            let model_btn = $('.shopify-model-viewer-ui__controls-overlay .shopify-model-viewer-ui__button');
            let label = $('.product-page--root').data('3d-label') || null;

            if (model_btn.length && label) {
                // $(window).on('load', function() {
                //     model_btn.find('svg').remove();
                //     model_btn.html('<span class="sw-3d-label">' + label + '</span>');
                // });
            }

            $(window).on('load', function () {

                let view_3d_btn = $('.shopify-model-viewer-ui__controls-overlay > button');
                let label = $('.product-page--root').data('3d-label') || null;

                if (view_3d_btn.length && label) {

                    view_3d_btn.append('<span class="shopify-model-viewer-ui__poster-control-label">' + label + '</span>');
                }
            })
        },
    },

    artist: {

        init: function () {

            console.log('Sw.artist.init called');

            // Construct artist profile content
            if (typeof sw_artists != 'undefined') {

                $('.js-artist-first-name').text(sw_artists[sw_artist].first_name);
                $('.js-artist-last-name').text(sw_artists[sw_artist].last_name);
                $('.js-artist-biography').replaceWith(sw_artists[sw_artist].biography);
                $('.js-artist-biography-mobile').replaceWith(sw_artists[sw_artist].biography.replace(/\n/g, '<br /><br />'));
                $('.js-artist-username').text(sw_artists[sw_artist].username);
                $('.js-artist-image-mobile').attr('src', sw_artists[sw_artist].img_mobile).attr('alt', sw_artists[sw_artist].first_name + sw_artists[sw_artist].last_name);
                $('.js-artist-image-desktop').attr('src', sw_artists[sw_artist].img_desktop).attr('alt', sw_artists[sw_artist].first_name + sw_artists[sw_artist].last_name);
                $('.js-artist-designs-count').text(sw_artists[sw_artist].designs_count);
                $('.js-artist-subscribed-at').text(sw_artists[sw_artist].subscribed_at);

                $.each(sw_artists[sw_artist].styles, function (key, style) {
                    $('.js-artist-styles').append('<li>- ' + style + '</li>');
                });

                $.each(sw_artists[sw_artist].social_links, function (key, social) {
                    $('.js-artist-social-links').append('<li><a href="' + social.link + '" target="_blank">' +
                        '<img src="' + social.icon + ' " alt="' + social.media + '" /><span>' + social.text + '</span></a></li>');
                });
            }

            // Artist paragraphs split
            let desktop_paragraphs = $('.desktop--profile-container .profile--about p');

            if (desktop_paragraphs.length) {

                console.log('desktop paragraphs initiated');

                let max_length = 210;

                $.each(desktop_paragraphs, function () {

                    let string = sw_artists[sw_artist].biography.replace('<p>', '').replace('</p>', '');

                    if (string.length > max_length) {

                        let visible_part = string.substring(0, max_length).replace(/\n/g, '<br /><br />');
                        let hidden_part = string.substring(max_length, string.length).replace(/\n/g, '<br /><br />');

                        $(this).empty().html(visible_part);
                        $(this).append('<span class="js-sw-description-hidden-part d-none">' + hidden_part + '</span>');

                        $('.read-more-container').appendTo($(this)).removeClass('d-none');
                        $('.read-less-container').appendTo($(this));
                    }

                });

                $(document).on('click', '.js-sw-description-read-more', function () {
                    $(this).closest('span').siblings(".js-sw-description-hidden-part").removeClass('d-none');
                    $('.read-more-container').addClass('d-none');
                    $('.read-less-container').removeClass('d-none');
                });

                $(document).on('click', '.js-sw-description-read-less', function () {
                    $(this).closest('span').siblings(".js-sw-description-hidden-part").addClass('d-none');
                    $('.read-more-container').removeClass('d-none');
                    $('.read-less-container').addClass('d-none');
                });
            }

            // Artist profile tabs
            let profile_tabs = $('#js_profile_mobile_tabs');

            if (profile_tabs.length) {

                let product_collection_id = $('#js_profile_mobile_tabs .profile--collection').attr('id');

                $(document).on('click', '.js-sw-mobile-show-profile-tabs', function (event) {

                    $(this).closest('ul').find('a').removeClass('inactive');

                    if ($(this).attr('aria-expanded')) {
                        $(this).addClass('inactive');
                    }
                });

                profile_tabs.on('show.bs.collapse', function (event) {

                    if ($(event.target).attr('id') === product_collection_id) {
                        $('.sw--collection--header--profile').removeClass('d-none');
                        $('.navigation--root').removeClass('d-none');
                        $('.collection--body--root').removeClass('d-none');
                    } else {
                        $('.sw--collection--header--profile').addClass('d-none');
                        $('.navigation--root').addClass('d-none');
                        $('.collection--body--root').addClass('d-none');

                    }
                })
            }

        }
    },

    getAccountCustomerDesigns: function(customer_id) {

        let self = this;

        console.log('Sw.account.getAccountCustomerDesigns for customer_id: ' + customer_id || 'null' + ' and product_id: ' + product_id || 'null');

        let ajax_ur = '/a/spirit-bo/designs/customer/' + customer_id;

        $.ajax({
            url: ajax_ur,
            method: 'GET',
            timeout: 0,
            async: false,
            headers: { "Accept": "application/json" },
            success: function (response) {
                console.log('Sw.account.getAccountCustomerDesigns RESPONSE: ', response);

                if (response.errors) {
                    console.log('ERRORS: ', response.errors);
                }
                else {

                    self.showDesignsInAccountPage(response.designs);
                }
            }
        }).fail(function() {
            console.log('ERROR: Sw.account.getCustomerDesigns AJAX failed!');
        });
    },

    showDesignsInAccountPage(designs) {

        let designs_container = $('.js-my-designs-list');

        if ($.isEmptyObject(designs)) {

            designs_container.closest('.account--designs-grid').find('.js-my-designs-empty').removeClass('d-none');

        }
        else {

            $.each(designs, function(key, design) {

                let date = design.updated_at.substring(0, design.updated_at.indexOf('T'));
                let delete_url = "/a/spirit-bo/designs/customer/" + design.customer_id + "/design/" + design.uuid;

                let thumb = '<li data-design_id="' + design.uuid + '">' +
                  '<div class="thumbnail"><img class="thumbnail-image" src="' + design.thumbnail + '" alt="' + design.product_name + '" onerror="this.style.visibility=\'hidden\'" />' +
                  '<a href="'+design.product_url+'?design_id='+design.uuid+'" class="design-edit">' +
                  '<span><img src="' + designs_container.data('edit_icon') + '" /></span></a>' +
                  '<a href="javascript:;" data-href="' + delete_url + '" class="design-delete" data-bs-toggle="modal" data-bs-target="#sw_my_designs_delete_modal">' +
                  '<span><img src="' + designs_container.data('delete_icon') + '" /></span></a></div>' +
                  '<h5>' + design.product_name + '</h5>' +
                  '<p><span>' + designs_container.data('modified') + ' ' + date + '</span></p></li>';
                designs_container.append(thumb);
            });
        }
    },

    logData: function (text, variable) {

        let self = this;
        let option = variable || null;

        if (self.conf.debug && window.console) {

            if (option) {
                console.log(text, option);
            } else {
                console.log(text);
            }
        }
    }
}

$(document).ready(function() {
    Sw.init();
});
